import React from 'react';
import PropTypes from 'prop-types';

// Components
import BackButton from '../BackButton';

export default function SecondaryView(props) {
  const { className, children, onBack, title } = props;

  return (
    <div className={className}>
      {onBack && <BackButton onClick={onBack}>{title}</BackButton>}
      {children && <div>{children}</div>}
    </div>
  );
}

SecondaryView.defaultProps = {
  className: '',
  title: '',
  children: null,
};

SecondaryView.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  children: PropTypes.any,
};
